<template lang="pug">
.card.height-100
  .card-body
    .columns
      .column.col-3
        img.img-responsive(v-if='product.cover', :src='product.cover')
        .empty(v-else)
          .fas.fa-camera
      .column.col-9
        .text-bold.text-ellipsis {{ product.title }}
        .mt-1
          div Status: #[span.text-bold(:class='product.status ? "text-success" : "text-error"') {{ product.status ? 'Ativo' : 'Inativo' }}]
        small.label.label-primary.label-rounded(
          v-if='product.monetizationForFiliations'
        ) Monetização ativada
        div
          small(v-for="(lang, index) in product.availableLanguages") {{ `${lang}${product.availableLanguages.length > index + 1 ? ', ' : ''}` }}
  .card-footer
    .columns.align-center
      .column
        .text-small Adicionado em #[span.text-bold {{ product.createdAt | toDate('DD/MM/YYYY') }}]
      .column.col-auto
        a.btn.btn-action.btn-sm.text-warning.btn-link.tooltip(
          data-tooltip='Duplicar',
          @click='duplicate',
          :disabled='loading'
        )
          .mt-1.loading.loading-sm(v-if='loading')
          i.fas.fa-copy(v-else)
        a.btn.btn-action.btn-sm.text-error.btn-link.tooltip(
          data-tooltip='Excluir',
          @click='$emit("remove", product)'
        )
          i.fas.fa-trash-alt
        a.btn.btn-link.btn-sm.tooltip(
          :class='status.action.class',
          :data-tooltip='status.action.label',
          @click='$emit(status.action.event, product)'
        )
          i(:class='status.action.icon')
        router-link.btn.btn-action.btn-sm.btn-link.tooltip(
          :to='{ name: `${product.productType}s.edit`, params: { id: product.id } }',
          data-tooltip='Editar'
        )
          i.fas.fa-edit
</template>

<script>
import products from '@/services/products'

const status = {
  true: {
    label: 'Ativo',
    class: 'text-success',
    action: {
      event: 'deactivate',
      label: 'Inativar',
      icon: 'fas fa-lock',
      class: 'text-error',
    },
  },
  false: {
    label: 'Inativo',
    class: 'text-error',
    action: {
      event: 'activate',
      label: 'Ativar',
      icon: 'fas fa-lock-open',
      action: 'text-success',
    },
  },
}
export default {
  data() {
    return { loading: false }
  },

  props: {
    product: { type: Object, required: true },
  },

  computed: {
    status() {
      return status[this.product.status]
    },
  },

  methods: {
    async duplicate() {
      try {
        this.loading = true
        const { data } = await products.duplicate(this.product.id)
        console.log(data)
        this.$router.push(`edit/${data.id}`)
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.empty
  padding 2rem 0
</style>
